import { ApplicationConfig } from '@angular/core';
import { createAppConfig } from 'credo';
import { MenuService } from 'app';
import { Logo } from 'shared';
import { routes } from './app.routes';
import { logo } from './assets/icons/logo';
import { environment } from './environments/environment';
import { DistributionMenuService } from './services/distribution-menu.service';

// "distribution" (wolfpack-distribution.com) is functionally identical to the
// fac3less app and reuses its translations — same backend tenant (domain_id 0) —
// but carries the Wolfpack visual design (logo + dark cyberpunk theme).
// The "distribution" scope is layered AFTER "fac3less" so it can override just
// the branded keys (e.g. app.name) while inheriting everything else from fac3less.
export const appConfig: ApplicationConfig = createAppConfig({
  routes,
  // Override the shared credo menu with the distribution menu (adds WPCP admin items).
  // Passed providers are spread after createAppConfig's defaults, so this wins.
  providers: [{ provide: MenuService, useClass: DistributionMenuService }],
  translationScope: 'fac3less,distribution',
  // Cookie banner + preference center (Tracking Engine V2, docs/tracking/EVENT_CONTRACT_V2.md).
  // pageId: tracking page of the app outside its checkout; policyKey: document the banner links to.
  consent: { enabled: true, pageId: 'wd-app', policyKey: 'privacy' },
  environment,
  theme: {
    mode: 'dark',
    colors: {
      primary:   "#00E5FF",
      secondary: "#050505",
      success:   "#00FF9F",
      info:      "#39f",
      warning:   "#f9b115",
      danger:    "#e55353",
      light:     "#ffffff",
      dark:      "#1B1B1B"
    }
  },
  logo: {
      type: 'icon',
      value: logo,
      name: 'wolfpack-logo',
      cssClass: 'logo'
  } as Logo
});